<script setup lang="ts">
  import type { DocumentRevision } from '@/entities/Document';
  import { IconButton, IconImage, Tooltip } from '@/shared/ui';
  import { useDocumentActions } from '../model/useDocumentActions';
  import HistoryIcon from '@/shared/assets/icons/HistoryIcon.svg';
  import SettingsIcon from '@/shared/assets/icons/SettingsIcon.svg';
  import LinkIcon from '@/shared/assets/icons/LinkIcon.svg';
  import Lesson1Icon from '@/shared/assets/icons/Lesson1Icon.svg';
  interface Props {
    document: DocumentRevision;
  }

  const props = defineProps<Props>();
  const { openModal, copyDocumentLink } = useDocumentActions();

  const openHistory = () => {
    openModal(props.document, 'history', { title: 'Histórico de documentos' });
  };

  const openTraining = () => {
    openModal(props.document, 'training', { title: 'Controle de Treinamento' });
  };

  const openControl = () => {
    openModal(props.document, 'control', { title: 'Controle de documentos' });
  };

  const copyLink = () => {
    copyDocumentLink(props.document);
  };
</script>

<template>
  <div class="flex gap-2 text-gray-xx-02">
    <Tooltip
      content="Histórico"
      placement="top"
      class="flex items-center"
    >
      <IconButton
        :src="HistoryIcon"
        alt="Histórico"
        @click="openHistory"
      />
    </Tooltip>

    <Tooltip
      content="Treinamento"
      placement="top"
      class="flex items-center"
    >
      <IconButton
        :src="Lesson1Icon"
        alt="Treinamento"
        @click="openTraining"
      />
    </Tooltip>

    <Tooltip
      content="Controle"
      placement="top"
      class="flex items-center"
    >
      <IconButton
        :src="SettingsIcon"
        alt="Controle"
        @click="openControl"
      />
    </Tooltip>

    <Tooltip
      content="Copiar link"
      placement="top"
      class="flex items-center"
    >
      <button
        type="button"
        class="inline-flex size-6 shrink-0 items-center justify-center text-gray-xx-02 [&_svg]:size-full"
        @click="copyLink"
      >
        <IconImage
          :src="LinkIcon"
          alt="Copiar link"
        />
      </button>
    </Tooltip>
  </div>
</template>
